<div class="container">
  <svg
    [ngStyle]="styleObject"
    [ngClass]="transitionEffect"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="11px"
    height="11px"
    viewBox="0 0 11 11"
  >
    <path
      fill-rule="evenodd"
      fill="rgb(135, 155, 175)"
      d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
    ></path>
  </svg>
</div>
